module.exports = "<p>\r\n  statlistecommande works!\r\n</p>\r\n"